import { render, staticRenderFns } from "./DadosPessoais.vue?vue&type=template&id=709612ee&scoped=true"
import script from "./DadosPessoais.vue?vue&type=script&lang=js"
export * from "./DadosPessoais.vue?vue&type=script&lang=js"
import style0 from "./DadosPessoais.vue?vue&type=style&index=0&id=709612ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709612ee",
  null
  
)

export default component.exports